if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    // Last shown progress, so a freshly re-rendered bar animates from it instead of jumping.
    static lastProgress = null;

    connectedCallback() {
      this.fill = this.querySelector('.free-shipping-bar__fill');
      this.text = this.querySelector('.free-shipping-bar__text');
      this.track = this.querySelector('.free-shipping-bar__track');

      const target = parseFloat(this.fill.style.width) || 0;
      if (FreeShippingBar.lastProgress !== null && FreeShippingBar.lastProgress !== target) {
        this.fill.style.width = `${FreeShippingBar.lastProgress}%`;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.fill.style.width = `${target}%`)));
      }
      FreeShippingBar.lastProgress = target;
    }

    render(cart) {
      const threshold = parseInt(this.dataset.threshold, 10);
      const total = cart.total_price;
      const remaining = threshold - total;
      const progress = Math.min(100, Math.floor((total * 100) / threshold));

      this.classList.toggle('hidden', cart.item_count === 0);
      this.text.innerHTML =
        remaining > 0
          ? this.dataset.textRemaining.replace('[amount]', formatFreeShippingMoney(remaining, this.dataset.moneyFormat))
          : this.dataset.textAchieved;
      this.fill.style.width = `${progress}%`;
      this.fill.classList.toggle('free-shipping-bar__fill--done', remaining <= 0);
      this.track.setAttribute('aria-valuenow', progress);
      FreeShippingBar.lastProgress = progress;
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);

  function formatFreeShippingMoney(cents, format) {
    const withDelimiters = (number, precision, thousands = ',', decimal = '.') => {
      const [whole, fraction] = (number / 100).toFixed(precision).split('.');
      const wholeFormatted = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return fraction ? `${wholeFormatted}${decimal}${fraction}` : wholeFormatted;
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
      switch (placeholder) {
        case 'amount_no_decimals':
          return withDelimiters(cents, 0);
        case 'amount_with_comma_separator':
          return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_space_separator':
          return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(cents, 0, ' ');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_period_and_space_separator':
          return withDelimiters(cents, 2, ' ', '.');
        default:
          return withDelimiters(cents, 2);
      }
    });
  }

  function refreshFreeShippingBars() {
    fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => document.querySelectorAll('free-shipping-bar').forEach((bar) => bar.render(cart)))
      .catch((e) => console.error(e));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFreeShippingBars);
  }

  // Cart may change in another tab or via back/forward cache.
  window.addEventListener('pageshow', (event) => event.persisted && refreshFreeShippingBars());
}
